/* ==========================================================================
   Keookies motion — reversible scroll reveal
   --------------------------------------------------------------------------
   Adds [data-kk-in] when an element enters the viewport and REMOVES it when it
   leaves. Because the CSS drives everything off that one attribute with a
   transition, the motion plays forward on the way down and unplays on the way
   back up -- reversible, without depending on scroll-driven CSS animations.

   Why not `animation-timeline: view()`:
   It is the "proper" native tool and it was tried first, but support is uneven
   across the iOS Safari versions that dominate this store's traffic, and when
   it is unsupported the element simply never moves. This approach uses
   IntersectionObserver + CSS transitions, which work everywhere and are
   verifiable in a headless browser -- scroll-driven timelines are not.

   Safety properties:
   - .kk-motion-ready is set by the inline snippet in snippets/kk-motion.liquid
     BEFORE first paint, so nothing flashes visible and then hides.
   - That snippet only sets the class when IntersectionObserver exists, so a
     browser that cannot run the observer never hides content it cannot reveal.
   - Any error hard-reveals everything rather than risk hiding content.
   ========================================================================== */

(function () {
  'use strict';

  var SELECTOR = '[data-kk-reveal]';
  var observer = null;

  function revealAll() {
    var nodes = document.querySelectorAll(SELECTOR);
    for (var i = 0; i < nodes.length; i++) {
      nodes[i].setAttribute('data-kk-in', '');
    }
  }

  function onIntersect(entries) {
    for (var i = 0; i < entries.length; i++) {
      var entry = entries[i];
      if (entry.isIntersecting) {
        entry.target.setAttribute('data-kk-in', '');
      } else {
        // Reverse. Only un-reveal below the fold: an element that has scrolled
        // off the TOP is behind the reader, and un-revealing it there causes a
        // visible re-animation when they scroll back down past content they
        // have already seen.
        var rect = entry.boundingClientRect;
        if (rect.top > 0) {
          entry.target.removeAttribute('data-kk-in');
        }
      }
    }
  }

  function init() {
    if (!('IntersectionObserver' in window)) {
      revealAll();
      return;
    }

    try {
      if (observer) observer.disconnect();

      observer = new IntersectionObserver(onIntersect, {
        // Trigger a little before the element is fully on screen so the motion
        // is already under way by the time it is comfortably in view.
        rootMargin: '0px 0px -12% 0px',
        threshold: 0,
      });

      var nodes = document.querySelectorAll(SELECTOR);
      for (var i = 0; i < nodes.length; i++) {
        observer.observe(nodes[i]);
      }
    } catch (err) {
      revealAll();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Theme editor re-renders sections on every setting change, producing fresh
  // un-revealed nodes. Re-observe so Kevin and Linda never see blank sections
  // while editing.
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:select', revealAll);
})();
